import styled from 'styled-components'

import { HtmlWidgetSizeType } from './types'

export const HtmlWidgetWrapper = styled.div<{
  $htmlWidgetSize?: HtmlWidgetSizeType
}>`
  position: relative;
  height: ${({ $htmlWidgetSize }) =>
    $htmlWidgetSize ? `${$htmlWidgetSize.height}px` : '100%'};
  width: ${({ $htmlWidgetSize }) =>
    $htmlWidgetSize ? `${$htmlWidgetSize.width}px` : '100%'};

  iframe {
    display: block;
    width: 100%;
    height: auto;
    min-height: 100%;
    opacity: 0;
    transition: all 0.2s ease-out;
    pointer-events: none;
    &.isVisible {
      opacity: 1;
    }
  }
`
